module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAFAAAAAAnxZisAAABD0lEQVQ4Ec2VvWoCQRSFnazBQqxFCAE70UUsBcUU1klpnkICwc4H2MZnsdfKShFsxU7QQvERJD/jd4SVLdLthXjgY/ay7JnDvTu7LoO8922WFjyoNtAvHkvn3Mxh3qGYQs7AOGnxRfGmxE2wNtdGj/Cu9tRgD9Y6YNhw2oqLJ5YQAtUG0gzWzGBv4PXPFtcWKQNtylpmoT3f8tNrmmeN4AUsz8Ecv4FS96AP1qpjeFBiqzfnr4CBWlTgzgh0oi1btMDvIzlkneZbzXUaeYZ8TmNwP8/Gn4oikapgNQOP14Y2HXXAKrAFa+0wDJX4FcpgrWcMP7XBCvRzsNYPhuN4Bl2KIZRAn9o0UugTRMxgcgFwRvXTPa1/6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu-bar.png
// module id = tx+H
// module chunks = 1